import { StateLabel } from 'components/Zui'

export const Static = ({ field }) => {
    const { value } = field

    return <span style={{ lineHeight: '30px' }}>{value}</span>
}

export const Badge = ({ field, ...props }) => {
    const { value } = field

    return (
        <div className="user-status-wrap">
            <StateLabel state={props.badgeState}>
                <span>{value}</span>
            </StateLabel>
        </div>
    )
}

export const BadgeWithText = ({ field, ...props }) => {
    const { value } = field

    return (
        <div className="user-status-wrap">
            <StateLabel state={props.badgeState}>
                <span>{value}</span>
            </StateLabel>
            <span className="invite-validity-wrap">{props.text}</span>
        </div>
    )
}
